export const MEDICATION_TAB_LIST = ['intakes', 'medicationManagement']

export const MEDICATION_PATIENT_DEFAULT_SORT = {
  sortedColumn: 'defaultSort',
  sortedColumnOrder: 'descend'
}

export const RPM_HISTORY_DEFAULT_SORT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'descend'
}

export const MEDICATION_ADMIN_DEFAULT_SORT = {
  sortedColumn: 'name',
  sortedColumnOrder: 'ascend'
}

export const MEDICATION_INTAKES_STATUS_LIST = [
  { key: 0, value: 1, title: 'Active' },
  { key: 1, value: 2, title: 'Completed' },
  { key: 2, value: 3, title: 'Expired' },
  { key: 3, value: 4, title: 'Skipped' }
]
